import styles from './search-title.module.scss';

export type SearchTitleProps = {
  searchTerm?: string;
};

export const SearchTitle: React.FC<SearchTitleProps> = ({ searchTerm }) => {
  return <h1 className={styles.title}>Showing results for “{searchTerm}”</h1>;
};
